import React from "react";
import { map } from "lodash";
import FileRow from "components/chat/shared/FileRow";

type FileAttachmentsArgs = {
  chatId: string;
  files: {
    content_type: string;
    extension: string;
    id: string;
    name: string | null;
    original_filename: string;
    created_at: string;
    size: number;
  }[];
};

export default function FileAttachments({
  files,
  chatId,
}: FileAttachmentsArgs) {
  return (
    <div className="flex flex-col gap-1 py-2 text-sm bg-white rounded">
      {map(files, (file, index) => (
        <FileRow key={index} className="!gap-1" chatId={chatId} {...file} />
      ))}
    </div>
  );
}
